import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=389eb5a4&scoped=true"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"
import style0 from "./Cart.vue?vue&type=style&index=0&id=389eb5a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389eb5a4",
  null
  
)

export default component.exports